module.exports = __webpack_public_path__ + "files/2f3f6acad5804ea510cd384f0c5bfd47.png";